import { render, staticRenderFns } from "./QuizBlocking.vue?vue&type=template&id=5b17270a&lang=pug"
import script from "./QuizBlocking.vue?vue&type=script&lang=ts"
export * from "./QuizBlocking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports